import type { ViewKeywordDto } from '@adflow/shared/data-google-ads';

/**
 * Should mimic the behavior of the LIKE operator in MySQL.
 *
 * `UPPER(value) LIKE '%' + UPPER(search) + '%'`
 */
function like(value: string, search: string) {
	return value.toUpperCase().includes(search.trim().toUpperCase());
}

interface SearchKeywordArgs {
	keyword: ViewKeywordDto;
	search: string;
	visibleColumns: string[];
}

export function searchKeyword({ keyword, search }: SearchKeywordArgs) {
	const matches: string[] = [];

	for (const listItem of keyword.list ?? []) {
		if (like(listItem, search)) {
			matches.push(listItem);
		}
	}

	return matches.length > 0 ? `Keywords: ${matches.join(', ')}` : undefined;
}
